'use strict';

module.exports = {
  TYPING: 'client-typing',
  NEW_COMMENT: 'new-comment',
  POST_PUBLISHED: 'post-published',
  NEW_NOTIFICATION: 'new-notification',
  UPDATE_POST_COUNTERS: 'update-post-counters',
  USER_UPDATED: 'user-updated',
  POSTS_IMPORTED: 'posts-imported'
};